export default {
  apiUrl : 'https://api.livartis.jp',
  url : 'www.livartis.jp',
  movieUrl: '#'
}
